import { Link } from "react-router-dom";
import HomeHero from "./components/HomeHero";
import CategoryEntry from "./components/CategoryEntry";
import LatestGrid from "./components/LatestGrid";
import Collections from "./components/Collections";
import { useSeo } from "@/hooks/useSeo";

export default function Home() {
  useSeo({
    title: "兔六影院-最新电影电视剧在线观看平台",
    description:
      "兔六影院提供海量最新电影和电视剧资源，涵盖多种类型，方便用户在线播放和观看精彩影视内容。",
    keywords:
      "兔六影院,电影在线观看,电视剧观看,影视资源,高清影视,热门电影,最新电视剧",
  });

  return (
    <div>
      <HomeHero />
      <CategoryEntry />
      <LatestGrid />
      <Collections />

      <section className="mx-auto w-full max-w-[1440px] px-4 md:px-8 py-10 md:py-14">
        <div className="grid grid-cols-1 gap-6 rounded-lg border border-background-200 bg-background-100 p-6 md:grid-cols-3 md:p-10">
          <div className="md:col-span-2">
            <span className="text-sm font-medium text-accent-600">关于兔六影院</span>
            <h2 className="mt-2 font-heading text-xl font-black text-foreground-950 md:text-3xl">
              一站式影视内容发现平台
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
              兔六影院专注于影视内容的浏览与介绍，聚合电影、电视剧两大内容板块，
              提供类型与年份筛选、关键词搜索、评分排序以及详尽的作品资料与相关推荐，
              帮助你用最短的时间找到真正想看的作品。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              本站所有影视信息均为演示数据，不提供内容存储与在线播放服务，
              收藏记录仅保存在你的本地浏览器中。
            </p>
            <Link
              to="/about"
              className="mt-6 inline-flex items-center gap-2 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer whitespace-nowrap"
            >
              了解更多
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="grid grid-cols-3 gap-3 md:grid-cols-1 md:gap-4">
            {[
              { value: "24+", label: "精选影视作品" },
              { value: "2", label: "核心内容频道" },
              { value: "12+", label: "细分题材分类" },
            ].map((stat) => (
              <div
                key={stat.label}
                className="rounded-lg bg-background-50 p-4 text-center md:text-left"
              >
                <p className="font-heading text-2xl font-black text-accent-600 md:text-3xl">
                  {stat.value}
                </p>
                <p className="mt-1 text-xs text-foreground-600">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}